import React from 'react'
import CustomSelect from '~/components/core/customSelect'

export const SimulatorFuelInput = (data) => {
  const {
    fuelType,
    setFuelType,
    price,
    setPrice,
    alertMessage,
    options,
    contentfulData,
  } = data

  const onChangeFunc = (optionSelected) => {
    setFuelType(optionSelected.value)
  }

  const onChangeMobile = (e) => {
    setFuelType(e.target.value)
  }

  const { section1Block1SelectLabel, section1InputLabel, section1Block1Titre } =
    contentfulData

  return (
    <div className="w-full md:w-1/2 simulator-block flex flex-col gap-6">
      <h3 className="title-block text-purple mr-8 !mb-0">
        {section1Block1Titre}
      </h3>
      <div className="flex w-full items-center gap-6 justify-between input-select-custom-wrapper">
        <p className="">{section1Block1SelectLabel}</p>
        <CustomSelect
          options={options}
          onChange={onChangeFunc}
          onChangeMobile={onChangeMobile}
          classes="react-select-container--sorting w-full input-select-custom-layout"
          classesMobile="input-select-custom"
          customDefaultValue={options.filter(
            (option) => option.value === fuelType,
          )}
        />
      </div>
      <div className="flex w-full input-select-custom-wrapper gap-6 justify-between">
        <p className="">{section1InputLabel}</p>
        <div
          className="relative max-w-200px min-w-200px w-full bg-light-grey input-select-custom"
          style={{ minWidth: '200px' }}
        >
          <input
            type="number"
            className=" !cursor-text w-full h-full bg-light-grey"
            value={price}
            onChange={(e) => setPrice(e.target.value)} // Ajout de cette ligne pour mettre à jour le prix
          />

          <p className="absolute text-xs text-orange-500 input-select-custom-footer">
            {alertMessage}
          </p>
        </div>
      </div>
    </div>
  )
}
